import { render, staticRenderFns } from "./小睡眠App《隐私政策》安卓.vue?vue&type=template&id=1a9b67ec&scoped=true"
import script from "./小睡眠App《隐私政策》安卓.vue?vue&type=script&lang=js"
export * from "./小睡眠App《隐私政策》安卓.vue?vue&type=script&lang=js"
import style0 from "./小睡眠App《隐私政策》安卓.vue?vue&type=style&index=0&id=1a9b67ec&prod&lang=scss&scoped=true"
import style1 from "./小睡眠App《隐私政策》安卓.vue?vue&type=style&index=1&id=1a9b67ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9b67ec",
  null
  
)

export default component.exports